var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { fill } from '../fill';
import { splice } from '../splice';
import { isNilOrEmpty } from '../../value/isNilOrEmpty';
import { isArray } from '../../type/isArray';
import { pad } from '../pad';
/**
 * Immutably inserts the item(s) at the specified index
 *
 * @category Array
 * @template {T} - The type of the array
 * @param {T[]} array - The original array
 * @param {number} index - The index of the array to start the insert; use negative value to index from the end of the array
 * @param {T[]} items - The item(s) to insert
 * @returns {T[]}
 * @example
 * insertAt([0, 1, 2], 1, [25])     //=> [0, 25, 1, 2]
 * insertAt([0, 1, 2], 1, [25, 26]) //=> [0, 25, 26, 1, 2]
 * insertAt([0, 1, 2], -2, [25])    //=> [0, 1, 25, 2]
 * insertAt([0, 1, 2], -5, [25])    //=> [25, undefined, 0, 1, 2]
 * @docgen_example
 * insertAt([0, 1, 2], 1, [25]);
 */
export var insertAt = function (array, index, items) {
    if (isNilOrEmpty(items))
        return isArray(array) ? array : [];
    if (!isArray(array))
        return fill(index).concat(items);
    if (index < 0 && Math.abs(index) > array.length) {
        return pad(items, Math.abs(index + array.length) - items.length).concat(array);
    }
    else if (index < 0) {
        return splice.apply(void 0, __spreadArray([array, array.length + index + 1, 0], items, false));
    }
    return splice.apply(void 0, __spreadArray([array, index, 0], items, false));
};
